import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Download, Apple, CheckCircle } from "lucide-react";

const DownloadSection = () => {
  const handleDownload = () => {
    window.open("https://singingfiles.com/show.php?l=0&u=2392393&id=69074", "_blank");
  };

  const features = [
    "Exklusive Spiele für iOS",
    "Sammle wertvolle Belohnungen",
    "Tägliche Boni und Geschenke",
    "Nur in Deutschland verfügbar"
  ];

  return (
    <section id="download" className="py-20 bg-gradient-to-b from-secondary/20 to-background px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute w-96 h-96 bg-primary/10 rounded-full blur-3xl top-0 -right-48"></div>
      <div className="absolute w-80 h-80 bg-primary/5 rounded-full blur-3xl -bottom-20 -left-20"></div>
      
      <motion.div 
        className="max-w-4xl mx-auto text-center relative z-10"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary mb-6">
          <Apple className="h-4 w-4 mr-2" />
          <span className="text-sm font-medium">iOS Exklusiv</span>
        </div>
        
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">
          Bereit für deine Belohnungen?
        </h2>
        
        <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Lade jetzt das erste Spiel in der Rewards App herunter und beginne, wertvolle Belohnungen zu sammeln.
        </p>
        
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="flex items-center bg-secondary/50 rounded-full px-4 py-2"
            >
              <CheckCircle className="h-4 w-4 text-primary mr-2" />
              <span className="text-sm font-medium">{feature}</span>
            </div>
          ))}
        </div>
        
        <Button 
          size="lg" 
          className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8 py-6"
          onClick={handleDownload}
        >
          Jetzt herunterladen
          <Download className="ml-2 h-5 w-5" />
        </Button>
        
        <p className="mt-4 text-sm text-muted-foreground">
          Nur verfügbar für iOS-Geräte in Deutschland
        </p>
      </motion.div>
    </section>
  );
};

export default DownloadSection;